import React from 'react';
import cn from 'classnames';
import Link from 'components/UI/Link';
import Icon from 'components/UI/Icon';
import Image from 'components/UI/Image';
import { useLang } from 'utils/localisation';
import { getOwnerPosition } from 'utils/owners';

import * as styles from './ManagementCard.module.scss';

export default function ManagementCard({ name, position, linkedin, photo, theme, isBigPersons }) {
  const lang = useLang();

  return (
    <div className={cn(styles.card, theme && styles[theme], isBigPersons && styles.bigPersons)}>
      <div className={styles.personData}>
        <Link href={linkedin} className={styles.linkedinLink}>
          <Icon name="linkedin-square" className={styles.linkedinIcon} />
        </Link>
        <p className={styles.name}>{name}</p>
        <p className={styles.position}>{getOwnerPosition(position, lang)}</p>
      </div>

      <div className={styles.pictureWrapper}>
        <Image className={styles.picture} classImage={styles.image} src={photo} />
      </div>
    </div>
  );
}
